import { formatDateReadable } from '@nemuru-eng/js-api-client';

import { Text } from '../../../../../../shared/components/Text';
import { PayoutsListRowProps } from '../../../types/PayoutsListRowProps';

export const payoutDateFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.35,
    field: 'issue_date',
    headerName: <Text tId={'CREATION_DATE'} />,
    align: 'left',
    searchable: false,
    defaultSort: 'desc',
    renderCell: (rowData: PayoutsListRowProps) => {
      return (
        <>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            {formatDateReadable(rowData.row.payoutDate)}
          </div>
        </>
      );
    },
  };
};
